import { render, staticRenderFns } from "./FilesViewer.vue?vue&type=template&id=1d598266&scoped=true&"
import script from "./FilesViewer.vue?vue&type=script&lang=js&"
export * from "./FilesViewer.vue?vue&type=script&lang=js&"
import style0 from "./FilesViewer.vue?vue&type=style&index=0&id=1d598266&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d598266",
  null
  
)

export default component.exports